import { render, staticRenderFns } from "./MaTestList.vue?vue&type=template&id=042923c8&scoped=true"
import script from "./MaTestList.vue?vue&type=script&lang=js"
export * from "./MaTestList.vue?vue&type=script&lang=js"
import style0 from "./MaTestList.vue?vue&type=style&index=0&id=042923c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042923c8",
  null
  
)

export default component.exports